import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync, cargarCatalogos } from '../../funciones_globales/catalogos';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import global_axios from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormImpor07  extends React.Component{
    constructor(props){
        super(props);
        this.state = {

            fechaDesde: null,
            fechaHasta: null,

            importacion_sel: null,
            proveedor_sel: null,
            tipoReporte: 'C',
        };
        //OP OVERCONTROLLS
        this.changeComponents = this.changeComponents.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impFlujoPagoImp = this.impFlujoPagoImp.bind(this);
        this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }


    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }
    

    changeYear(){
        if(this.state.periodo!==''){
            var anio = parseInt(this.state.periodo,10)
            var fechaInf = parseInt(this.state.anioActual,10) - 3;

            if(anio>parseInt(this.state.anioActual,10)){
                this.setState({periodo: parseInt(this.state.anioActual,10)});
            }else if(anio===parseInt(this.state.anioActual,10)){
                this.setState({periodo: anio});
            }else if(anio >= fechaInf && anio <=parseInt(this.state.anioActual,10)){
                this.setState({periodo: anio});
            }else{
                this.setState({periodo: parseInt(this.state.anioActual,10)});
                alert("Rango incorrecto para el periodo, máximo 3 años hacia atrás")
            }
        }
    }
    
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    componentDidMount(){
        Promise.all([
            cargarCatalogos('BODEGA'),
            cargarCatalogos_Otros('MESES'),
            this.props.generar_LogAuditoriaIngresoForm('0307')
         ])
        .then(([ bodega ]) => {

            let fechaProceso = getFechaProcesoPorModulo('03');

            //Asignacion de Fecha
            let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
            let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
            this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta,
            bodega_opt: bodega, bodega_sel: '01'})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0307');
    }

    validacionFechaConRagoPeridios(fechaDesde, fechaProceso){
        var result = false; 
        var i_fechaDesde = formatearFechaMoment_a_String(fechaDesde);

        var FechaTran = fechaProceso.split('/');
        var fechaMenos = fechaProceso.split('/');
        var c_fechaDesde = i_fechaDesde.split('/');
        fechaMenos = parseInt(fechaMenos[2],10) -4

        if(parseInt(c_fechaDesde[2],10)>=parseInt(fechaMenos,10) && parseInt(c_fechaDesde[2],10)<=parseInt(FechaTran[2],10)){
            result = true
        }
        return result;
    }

    validacionFechaTrabajo(fechaProceso, fecha){
        
        var respuesta;
        var i_fecha = formatearFechaMoment_a_String(fecha)
        let fechaPartProceso = fechaProceso.split('/');
        let fechaPart = i_fecha.split('/');
        
        if(fechaPart[2]===fechaPartProceso[2]){
            respuesta = true;
        }else{
            respuesta = false;
        }

        return respuesta;
    }

    limpiar(){

        //Asignacion de Fecha
        let fechaProceso = getFechaProcesoPorModulo('03');

        let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
        let fechaDesde = moment(fechaProceso, "DD/MM/YYYY");
        this.setState({fechaDesde: fechaDesde, fechaHasta: fechaHasta})

        this.setState({
            importacion_sel: null,
            proveedor_sel: null,
        })
    }

    impFlujoPagoImp(formatoReporte){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        let dataEnvio = {};
        let reporte;
        if (formatoReporte==='PDF'){
        reporte = 153;
        }
        else
        {
        reporte = 154;
        }
        

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        

        if(continuar === true){
            dataEnvio.fechadesde =formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde);
            dataEnvio.fechahasta =formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
            dataEnvio.tipoReporte =this.state.tipoReporte

            let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`
            urlReporte+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`
            urlReporte+=`&param3=${this.state.tipoReporte}`;
            
            if(this.state.importacion_sel!==null){
                dataEnvio.importacion =this.state.importacion_sel.value
            }
            else {dataEnvio.importacion =null}

            if(this.state.proveedor_sel!==null){
                dataEnvio.proveedor = this.state.proveedor_sel.value
            }else {dataEnvio.proveedor =null}

            
                let config_request = {
                    method: 'POST',
                    url: '/flujopagosimportacion',
                    data: dataEnvio
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then(()=>{

                    if (formatoReporte==='PDF'){
                    this.props.cambiar_VisualizacionLoading(false); 
                    visualizarReporteEnPdf(urlReporte);
                    }
                    else
                    {
                    this.props.cambiar_VisualizacionLoading(false); 
                    generarReporteEnExcel(urlReporte);
                    }


                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(error.response?error.response.data.msg:error.message);
                });
        }else{
            alert(error)
        }
    }

    
    cambiarValoresInput(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Flujo de Pagos</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'>
                            <Row>
                                <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='8'>
                                    <LabelForm>Desde:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5 col-sm-offset-4 col-sm-pull-4' margen_arriba='15' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-2' margen_abajo='4'>
                                    <LabelForm>Hasta:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5 col-sm-push-1' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                                </ContainerCol>
                            </Row>
                        </ContainerCol>

                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'> 
                            <Row>
                                <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm>Importación:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6 col-sm-offset-3 col-sm-pull-3' margen_arriba='15' margen_abajo='4'>
                                <ReactSelectAsync value={this.state.importacion_sel} disabled={this.state.operacion==='M'?true:false} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}}/>
                                </ContainerCol>
                            </Row>                           
                            <Row>
                                <ContainerCol className='col-sm-3' margen_abajo='4'>
                                    <LabelForm>Proveedor:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-9' margen_abajo='4'>
                                    <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.setState({proveedor_sel: value!==null?value:null})}}/>
                                </ContainerCol> 
                            </Row>                            
                                                        
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo de Reporte: </LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                                <div>                                
                                    <LabelForm className='radio-inline'>
                                        <input type="radio" name="tipoReporte" value="C" checked={this.state.tipoReporte==="C"} onChange={this.handleInputChange} /> Todas las Importaciones
                                    </LabelForm>
                                    <LabelForm className='radio-inline'>
                                        <input type="radio" name="tipoReporte" value="E" checked={this.state.tipoReporte==="E"} onChange={this.handleInputChange} /> Por Importacion Confirmada
                                    </LabelForm>
                                    <LabelForm className='radio-inline'>
                                        <input type="radio" name="tipoReporte" value="A" checked={this.state.tipoReporte==="A"} onChange={this.handleInputChange} />Por llegada Aduana
                                    </LabelForm>
                                </div>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <ContainerCol className='btn-group pull-right' margen_arriba='10'>
                                <button type='button' className='btn btn-info btn-sm'  onClick={()=>{this.impFlujoPagoImp('PDF')}}><i className="fa fa-print fa-lg"/> Imprimir</button>  
                                <button type='button' className='btn btn-success btn-sm'  onClick={()=>{this.impFlujoPagoImp('EXCEL')}}><i className="fa fa-file-excel-o fa-lg"/> Generar Excel</button>
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImpor07);